import React, {useEffect} from 'react';
import {connect, useDispatch} from 'react-redux'
import {Head, RoleCreate} from "../../../components";
import {Box, Paper} from "@mui/material";
import {Tooltip} from "@mui/material";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import {roleAction} from './../../../actions'
import {SET_ROLE} from "../../../types";
import {Permissions} from './../../../components'
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";


const Role = ({ fetchRoles, roles, authReducer }) => {

    const dispatch = useDispatch();

    useEffect(() => {
        handleRequest();
    }, []);

    const handleRequest = () => {
        fetchRoles();
        dispatch({type: SET_ROLE, payload: null})
    };


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت نقش ها', 'description': 'تعیین نقش ها و سطوح دسترسی' }} />
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1c-content"
                    id="panel1c-header"
                >
                    <div>
                        <Typography><b>راهنما</b></Typography>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <ul>
                        <li>امکان حذف نقش وجود ندارد.</li>
                        <li>جهت ویرایش عنوان از طریق دکمه پلاس کلید اصلی را تکرار کنید.</li>
                    </ul>
                </AccordionDetails>
            </Accordion>
            <Box mt={5}>
                <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                    {authReducer.user.permissions.user && Boolean(authReducer.user.permissions.user.store_roles_admin) && <RoleCreate reload={() => handleRequest()}/>}
                    {authReducer.user.permissions.user && Boolean(authReducer.user.permissions.user.get_permissions_admin) && roles.role &&  <Permissions role_id={roles.role}/>}
                    <Tooltip title="سینک" onClick={() => handleRequest()}>
                        <IconButton>
                            <SyncIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <Paper elevation={1} style={{ padding: '15px'}}>
                    <Grid container>
                        {roles.data && roles.data.map((item, index) => {
                            return(
                                <Grid key={index} item xs={12} sm={3}>
                                    <FormControlLabel key={index} control={
                                        <Radio
                                            checked={(roles.role ? roles.role : false ) === item.id}
                                            value={item.id}
                                            onChange={() => dispatch({type: SET_ROLE, payload: item.id})}
                                        />
                                    } label={item.title ? item.title : item.id} />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Paper>
            </Box>
        </Container>

    );
}


const mapStateToProps = state => ({
    roles: state.roleReducer,
    authReducer: state.authReducer
});

const mapDispatchToProps = (dispatch) => ({
    fetchRoles: () => {
        dispatch(roleAction.fetchRoles())
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Role)
